export const FEATURES = {
  OPS_MASKED_PHONE_NUMBERS: 'ops_masked_phone_numbers',
  REL_CONTRACTS_V2: 'rel_contracts_v2',
  REL_BREEDER_PAYMENT_ENFORCEMENT: 'rel_breeder_payment_enforcement',
  REL_SHARED_PICKUP_PLAN: 'rel_shared_pickup_plan',
  REL_INSURANCE_POST_PAYMENT_PROMPTS: 'rel_insurance_post_payment_prompts',
  REL_INTRO_CALLS: 'rel_intro_calls',
  REL_SIMILAR_BREEDS_FILTER: 'rel_similar_breeds_filter',
  REL_LITTER_PAGE: 'rel_litter_page',
  REL_FAVORITE_LITTERS: 'rel_favorite_litters',
  REL_MESSENGER_CLEANUP: 'rel_messenger_cleanup',
  REL_LITTER_PREFERENCE_UPDATE: 'rel_litter_preference_update'
};
